(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/prescript.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/prescript.js');
'use strict';

svs.selfExclusion = svs.selfExclusion || {};
svs.selfExclusion.components = svs.selfExclusion.components || {};
svs.selfExclusion.store = svs.selfExclusion.store || {};
svs.selfExclusion.constants = svs.selfExclusion.constants || {};
svs.selfExclusion.hooks = svs.selfExclusion.hooks || {};
svs.selfExclusion.models = svs.selfExclusion.models || {};
svs.self_exclusion_react = svs.self_exclusion_react || {};
svs.self_exclusion_react.data = svs.self_exclusion_react.data || {};

 })(window);